// Kept dependency-free so the builder and the render shell can share these ids without
// an import cycle through the cell registry's transitive imports.
export const SELECTION_COLUMN_ID = 'selection';
export const EDIT_COLUMNS_COLUMN_ID = 'edit-columns';
